import React, { useEffect, useState } from 'react';
import { Sidebar } from '../../components/Sidebar';
import { Header } from '../../components/Header';
import { StepIndicator } from '../../components/StepIndicator';
import { CheckCircleIcon, ImageIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const STEPS = ['Select Product', 'Background', 'Greetings', 'Store Info', 'Generate', 'Output Format'];
export function GenerateCreative() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [currentStep, setCurrentStep] = useState('Initializing...');
  useEffect(() => {
    const steps = [{
      label: 'Composing product and background...',
      duration: 1000
    }, {
      label: 'Adding greeting text...',
      duration: 800
    }, {
      label: 'Applying store information...',
      duration: 800
    }, {
      label: 'Finalizing creative...',
      duration: 600
    }];
    let currentProgress = 0;
    let stepIndex = 0;
    const interval = setInterval(() => {
      if (stepIndex < steps.length) {
        setCurrentStep(steps[stepIndex].label);
        const increment = 100 / steps.length;
        currentProgress += increment;
        setProgress(Math.min(currentProgress, 100));
        stepIndex++;
      } else {
        clearInterval(interval);
        setIsComplete(true);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1334">
      <Sidebar data-id="element-1335" />
      <main className="flex-1" data-id="element-1336">
        <Header data-id="element-1337" />
        <StepIndicator currentStep={5} steps={STEPS} data-id="element-1338" />
        <div className="px-6 py-8" data-id="element-1339">
          <div className="max-w-4xl mx-auto" data-id="element-1340">
            <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-1341">
              Step 5: Generate Creative
            </h1>
            <p className="text-gray-600 mb-6" data-id="element-1342">
              AI is generating your brand-compliant creative
            </p>

            {!isComplete ? <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-1343">
                <div className="text-center mb-8" data-id="element-1344">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-1345">
                    <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" data-id="element-1346"></div>
                  </div>
                  <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-1347">
                    {currentStep}
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1348">
                    This will only take a moment...
                  </p>
                </div>

                <div className="mb-4" data-id="element-1349">
                  <div className="flex justify-between text-sm text-gray-600 mb-2" data-id="element-1350">
                    <span data-id="element-1351">Progress</span>
                    <span data-id="element-1352">{Math.round(progress)}%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-3" data-id="element-1353">
                    <div className="bg-blue-500 h-3 rounded-full transition-all duration-500" style={{
                  width: `${progress}%`
                }} data-id="element-1354"></div>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-6" data-id="element-1355">
                  <h4 className="font-medium text-blue-900 mb-2" data-id="element-1356">
                    What's Happening?
                  </h4>
                  <ul className="text-sm text-blue-800 space-y-1" data-id="element-1357">
                    <li data-id="element-1358">• Composing product with selected background</li>
                    <li data-id="element-1359">• Adding greeting text with brand styling</li>
                    <li data-id="element-1360">• Applying store information in pre-set positions</li>
                    <li data-id="element-1361">• Ensuring brand compliance</li>
                  </ul>
                </div>
              </div> : <div className="space-y-6" data-id="element-1362">
                <div className="bg-green-50 border border-green-200 rounded-lg p-6" data-id="element-1363">
                  <div className="flex items-center" data-id="element-1364">
                    <CheckCircleIcon className="text-green-500 mr-3 flex-shrink-0" size={32} data-id="element-1365" />
                    <div data-id="element-1366">
                      <h3 className="text-lg font-medium text-green-900" data-id="element-1367">
                        Creative Generated Successfully!
                      </h3>
                      <p className="text-sm text-green-700" data-id="element-1368">
                        Your brand-compliant creative is ready
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1369">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1370">Preview</h3>
                  <div className="flex justify-center" data-id="element-1371">
                    <div className="w-96 h-96 bg-gradient-to-br from-blue-100 to-purple-100 rounded-lg flex items-center justify-center border-2 border-gray-200" data-id="element-1372">
                      <ImageIcon className="text-gray-400" size={64} data-id="element-1373" />
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 text-center mt-4" data-id="element-1374">
                    Static image creative with all your customizations
                  </p>
                </div>

                <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-1375">
                  <h3 className="font-medium text-gray-800 mb-4" data-id="element-1376">
                    Creative Details
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1377">
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1378">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1379">Format</p>
                      <p className="font-semibold text-gray-800" data-id="element-1380">
                        Square (1:1)
                      </p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1381">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1382">Resolution</p>
                      <p className="font-semibold text-gray-800" data-id="element-1383">
                        1080 x 1080 px
                      </p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1384">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1385">
                        Brand Compliance
                      </p>
                      <p className="font-semibold text-green-600" data-id="element-1386">✓ Verified</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1387">
                      <p className="text-sm text-gray-600 mb-1" data-id="element-1388">File Size</p>
                      <p className="font-semibold text-gray-800" data-id="element-1389">~2.5 MB</p>
                    </div>
                  </div>
                </div>

                <div className="flex justify-between" data-id="element-1390">
                  <button onClick={() => navigate('/dealer/ai-generator/step-4')} className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1391">
                    Back to Edit
                  </button>
                  <button onClick={() => navigate('/dealer/ai-generator/step-6')} className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors" data-id="element-1392">
                    Continue to Output Format
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </main>
    </div>;
}